<template>
  <component v-if="data" :is="themeName" :key="uuidValue" :data="data" />
</template>

<script>
import capitalize from 'lodash/capitalize'
import LandingPageMixin from '@/mixins/landingpage'
import { uuid } from '@/helpers'

export default {
  name: 'LandingPageHome',
  metaInfo () {
    const link = document.querySelector("link[rel*='icon']")
    link.href = this.metadata.href
    return {
      title: `Landing Page | ${capitalize(this.metadata.image)}`,
      meta: [
        { name: 'description', content: 'View the full Itinerary, how to book, &  further trip information here' },
        { name: 'title', content: `Landing Page | ${capitalize(this.metadata.image)}` },
        { property: 'og:title', content: this.metadata.title },
        { property: 'og:site_name', content: 'Landing Page' },
        { property: 'og:image', content: this.metadata.image },
        { property: 'og:url', content: this.metadata.url }
      ]
    }
  },
  mixins: [ LandingPageMixin ],
  computed: {
    uuidValue () {
      return uuid()
    },
    metadata () {
      if (this.data) {
        return {
          title: this.data.data.opportunity_name,
          description: this.data.data.reference_number,
          image: this.data.template,
          url: this.data.hash,
          href: `/landingpages/${this.data.template}/img/favicon.ico`
        }
      }
      return 'empty'
    },
    themeName () {
      if (this.data) {
        const prefix = 'LandingPage'
        const templateName = capitalize(this.data.template)
        if (templateName) {
          return `${prefix}${templateName}`
        }
        return `${prefix}Default`
        // return 'WebLinkInsightVacations'
      }
      return {}
    }
  }
}
</script>
